import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';
import { CheckListItem } from 'app/components/check-list/check-list.component';

@Component({
  selector: 'app-user-selection',
  templateUrl: './user-selection.component.html',
  styleUrls: ['./user-selection.component.scss'],
  animations: fuseAnimations,
})
export class UserSelectionComponent implements OnInit, AfterViewInit {

  @Input() users: User[] = [];
  @Input() selectedUsers: User[] = [];
  @Input() selectedGroup: CheckListItem = new CheckListItem(0, 'Custom', true);
  @Input() readOnly = false;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  userCheckList: CheckListItem[];
  userGroupCheckList: CheckListItem[];

  currentUserId: number;
  currentUser: User;

  constructor(private userService: UserService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.currentUserId = this.userService.getCurrentUserId();
    // this.currentUser = this.users.find((u) => u.id === this.currentUserId);
    this.currentUser = this.userService.getCurrentUser();
    this.setupUsers();
    this.setupUserGroups();
  }

  notifyChange() {
    const selectedItems = this.userCheckList.filter((item) => item.checked === true).map((item) => item.id.toString());
    const users = this.users.filter((user) => selectedItems.indexOf(user.id.toString()) !== -1);
    this.onChanged.emit(users);
  }

  setupUserGroups() {
    this.selectUserGroup();
    this.userGroupCheckList = [
      // new CheckListItem(1, 'No-one', (this.selectedGroup.name === 'No-one')),
      new CheckListItem(2, 'Me', (this.selectedGroup.name === 'Me')),
      new CheckListItem(3, 'Me and my manager', (this.selectedGroup.name === 'Me and my manager')),
      new CheckListItem(4, 'People in my team', (this.selectedGroup.name === 'People in my team')),
      new CheckListItem(5, 'Everyone', (this.selectedGroup.name === 'Everyone')),
    ];
  }

  setupUsers() {
    let selectedUsers = [];
    if (this.selectedUsers) {
      if ((this.selectedUsers.length === 0) && this.users) {
        this.selectedUsers = [...this.users];
      }
      selectedUsers = this.selectedUsers.map((i) => i.id);
    }
    this.userCheckList = this.users.map((user) => new CheckListItem(user.id, user.fullName, (selectedUsers.indexOf(user.id) !== -1)));
    this.onChanged.emit(this.selectedUsers);
  }

  usersChanged(item: CheckListItem) {
    this.userGroupCheckList.forEach((i) => i.checked = false);
    this.notifyChange();
  }

  userGroupChanged(item: CheckListItem) {
    this.selectedGroup = item;
    let users = [];
    let manager;
    switch (item.id) {
      case 1:
        // No-one
        this.deselectUsers();
        this.selectUsers([]);
        break;
      case 2:
        // Me
        this.deselectUsers();
        this.selectUsers([this.currentUser]);
        break;
      case 3:
        // Me and my manager
        this.deselectUsers();
        users.push(this.currentUser);
        manager = this.users.find((user) => user.id === this.currentUser.managerId);
        if (manager) {
          users.push(manager);
        }
        this.selectUsers(users);
        break;
      case 4:
        // People in my team
        this.deselectUsers();
        users = this.users.filter((user) => user.managerId === this.currentUserId);
        users.push(this.currentUser);
        this.selectUsers(users);
        break;
      case 5:
        // Everyone
        this.selectUsers([...this.users]);
        break;
    }
    this.notifyChange();
  }

  deselectUsers() {
    this.selectedUsers = [];
    this.userCheckList.forEach((item) => {
      item.checked = false;
    });
  }

  selectUsers(users) {
    users = users || [];
    this.selectedUsers = users;
    users.map((user) => {
      const item = this.userCheckList.find((u) => u.id === user.id);
      if (item) {
        item.checked = true;
      }
    });
  }

  selectUserGroup() {
    if ((this.selectedUsers.length === 1) && (this.selectedUsers[0].uid === this.currentUser.uid)) {
      // the only user selected is the current user, select the 'Me' group option
      this.selectedGroup = new CheckListItem(1, 'Me', true);
    }
    else {
      const everyone = this.users.map((i) => i.id).join(',');
      const manager = this.users.filter((user) => (user.id === this.currentUser.managerId) || (user.id === this.currentUserId)).map((i) => i.id).join(',');
      const team = this.users.filter((user) => (user.managerId === this.currentUserId) || (user.id === this.currentUserId)).map((i) => i.id).join(',');
      const selected = this.selectedUsers.map((i) => i.id).join(',');
      switch (selected) {
        case everyone: this.selectedGroup = new CheckListItem(4, 'Everyone', true); break;
        case manager: this.selectedGroup = new CheckListItem(3, 'Me and my manager', true); break;
        case team: this.selectedGroup = new CheckListItem(4, 'People in my team', true); break;
        default:
          break;
      }
    }
  }
}
